//vas types
export const FLIGHT_NOTIFICATIONS = 'FLIGHT_NOTIFICATIONS'
export const FLIGHT_DELAY_PROTECTION = 'FLIGHT_DELAY_PROTECTION'
export const LUGGAGE_PROTECTION = 'LUGGAGE_PROTECTION'
export const AUTO_CHECKIN = 'AUTO_CHECKIN'
export const MEDICAL_INSURANCE = 'MEDICAL_INSURANCE'
//vas providers
export const TRIPADD = 'TRIPADD'
export const TAWUNIYA = 'TAWUNIYA'
export const insuranceTypes = [
    FLIGHT_NOTIFICATIONS,
    FLIGHT_DELAY_PROTECTION,
    LUGGAGE_PROTECTION,
    AUTO_CHECKIN,
    MEDICAL_INSURANCE
]
